import { UseMutationOptions } from '@tanstack/react-query';
import { TranslationSettings, editTranslationSettings } from '~/monolith-api';
import { useLocalization } from '~/framework';
import { useRegisteredMutation } from '~/queries';

export function useEditTranslationSettings(
   options: UseMutationOptions<TranslationSettings, any, TranslationSettings> = {}
) {
   //    const { _js } = useLocalization();

   return useRegisteredMutation<TranslationSettings, any, TranslationSettings>(
      'translation-settings',
      async (translationSettings: TranslationSettings) => {
         return await editTranslationSettings(translationSettings);
      },
      {
         //  errorMessages: editCourse.errorMessages({
         //     'courses.course_not_found': _js('Course not found.'),
         //     'courses.edit.duplicate_title': _js(
         //        'The course title already exists. Please choose a different title.'
         //     ),
         //     default: _js('There was a problem saving your course. Please try again.'),
         //  }),
         ...options,
      }
   );
}
